import ClasificacionTerceroService from 'src/modules/clasificacionTercero/clasificacionTerceroService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'CLASIFICACIONTERCERO_FORM';

const clasificacionTerceroFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: clasificacionTerceroFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ClasificacionTerceroService.find(id);
      }

      dispatch({
        type: clasificacionTerceroFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: clasificacionTerceroFormActions.INIT_ERROR,
      });

      getHistory().push('/clasificacion-tercero');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: clasificacionTerceroFormActions.CREATE_STARTED,
      });

      await ClasificacionTerceroService.create(values);

      dispatch({
        type: clasificacionTerceroFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.clasificacionTercero.create.success'),
      );

      getHistory().push('/clasificacion-tercero');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: clasificacionTerceroFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: clasificacionTerceroFormActions.UPDATE_STARTED,
      });

      await ClasificacionTerceroService.update(id, values);

      dispatch({
        type: clasificacionTerceroFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.clasificacionTercero.update.success'),
      );

      getHistory().push('/clasificacion-tercero');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: clasificacionTerceroFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default clasificacionTerceroFormActions;
